module.exports = __webpack_public_path__ + "media/images/placeholder_eco-84df8c9f4a5a1d52196a1cc12d6cb8ac.png";